// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__RiahP","disabled":"FileBtn_disabled__2vBrS","warn":"FileBtn_warn__1KSYe","fade":"FileBtn_fade__3mfzp"};